// to be loaded on the product page
// this will poll for loxa and when it finds it setup a mutation observer to see when the atc changes
// it will reassign the new atc so the modal trigger can be attached
const loxaPoll = setInterval(() => {
    if (typeof window.Loxa !== 'undefined' && window.Loxa.atcId) {
        clearInterval(loxaPoll);

        if (Loxa.observer) {
            Loxa.observer.disconnect();
        }

        const currentBtn = document.querySelector(Loxa.atcId);
        const container = currentBtn ? currentBtn.closest('form') : document.querySelector('form[action*="/cart/add"]');

        if (container) {
            Loxa.observer = new MutationObserver((mutations) => {
                const hasStructureChanged = mutations.some(m => m.type === 'childList');
                if (hasStructureChanged) {
                    const candidateBtn = document.querySelector(Loxa.atcId);
                    if (candidateBtn && candidateBtn !== Loxa.atcBtn) {
                        Loxa.atcBtn = candidateBtn;
                        Loxa.debug("ATC Button element changed. Reference updated.");
                    }
                }
            });

            Loxa.observer.observe(container, {
                childList: true,
                subtree: true,
                attributes: false
            });
            
            Loxa.debug("Loxa Observer active.");
        }
    }
}, 500);